import { autoMount } from '../../../utils/autoMount';
import { PersonShow } from '../../../components/pages/personShow';

autoMount({ PersonShow });
